import * as React from 'react';
import { VisualItem } from './VisualItem';
import { NotVisualItem } from './NotVisualItem';

export interface IAttributeValueViewProps {
  attribute: GQL.IAttribute;
  value: GQL.IAttributeValue;
  onClick?: Function;
}

export default class AttributeValueView extends React.PureComponent<IAttributeValueViewProps> {
  public render() {
    return (
      <div
        onClick={(e: any) => {
          if (this.props.onClick) {
            this.props.onClick(e);
          }
        }}
        style={{ cursor: this.props.onClick ? 'pointer' : '' }}
      >
        {this.props.attribute.isVisual && (
          <VisualItem value={this.props.value} />
        )}
        {!this.props.attribute.isVisual && (
          <NotVisualItem value={this.props.value} />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Attributes/AttributeDetail/components/Values/components/AttributeValueShow.tsx